import React, {Component} from "react";
import 'semantic-ui-css/semantic.min.css';
import {Helmet} from "react-helmet";
import headerLogo from "../../../assets/new-logo.svg";
import FilterableRepeater from "../../../components/repeater/filterable-repeater";
import ClientElement from "./client-element";
import * as api from "../../../api";
import "./client-selector.scss"
import PropTypes from "prop-types";

export default class ClientSelector extends Component {

    constructor(props)
    {
        super(props);
        this.state = {
            clientList: [],
        };

        this.fetchData();
    }

    fetchData() {
        try {
        
        api.getCustomerList()
            .then(data => {
                this.setState({clientList: data});
            }).catch(function(error) {
                // Acquire token interactive failure
                console.log(error);
            });

    
        }
        catch(err) {
            console.log(err);       
        
        } 
            
    }

    render() {
        return (
            <div className="client-selector">

                <Helmet>
                    <title>Inenco Portal | Account Selection</title>
                </Helmet>

                <img src={headerLogo} alt="header-logo" id="logo"/>
                <h4>Please select an account</h4>

                <FilterableRepeater data={this.state.clientList} component={ClientElement} textFilterFields={["name"]} onElementInteraction={this.props.onSelectedClient}/>

            </div>
        );
    }
}

ClientSelector.propTypes = {

    
    onSelectedClient: PropTypes.func
};

